module.exports = __webpack_public_path__ + "assets/a6bf70611e061c1c8df4057f853fba06.png";